/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ vat: NonNullable<unknown> }} Online_Price_SubtitleInputs */

const vi_online_price_subtitle = /** @type {(inputs: Online_Price_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Giá gồm VAT bán trên website. SKU chưa đặt giá Online bán theo giá ERP + VAT ${i?.vat}%. Không đổi giá sản phẩm trong ERP.`)
};

/**

* @param {Online_Price_SubtitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const online_price_subtitle = /** @type {((inputs: Online_Price_SubtitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Online_Price_SubtitleInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_online_price_subtitle(inputs)
});